import React from "react";
import { motion } from "framer-motion";
import FirstSlider from "./FirstSlider";
import finalvid from "../../assests/finalvid.mp4";

const Home = () => {
  return (
    <div className="bg-white">
      <div className="bg-gradient-to-r from-[#201C59] to-indigo-700 text-white py-24 px-6 md:px-20 text-center mb-10 rounded-b-3xl shadow-lg">
        <motion.h1
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="text-white text-5xl md:text-7xl font-bold drop-shadow-lg"
        >
          Welcome to <span className="text-yellow-400">DTEC</span>
        </motion.h1>
        <motion.p
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.9, duration: 0.8 }}
          className="mt-6 text-white/90 text-lg max-w-3xl mx-auto text-center"  //md:text-2xl  
        >
          Innovative, reliable, and scalable technology solutions for your business success.
        </motion.p>
      </div>
      {/* Hero Slider */}
      <FirstSlider />

      {/* Fullscreen Video Section */}        
      {/* Video */}

      {/* <div className="relative w-full h-screen flex items-center justify-center">
        <motion.video
          src={finalvid}
          autoPlay
          loop
          muted
          controls={false}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center text-center"></div>
      </div> */}

    </div>
  );
};

export default Home;
